// Skeleton sutil estilo Untitled UI: blocos gray-100 uniformes com pulse
// soft (90 por cento amplitude reduzida). Espelha estrutura do card real
// para evitar layout shift quando os dados chegam.
export const MatchCardSkeleton = () => (
  <div
    className="flex animate-pulse-soft flex-col gap-3 rounded-3xl bg-white p-4 sm:flex-row sm:gap-4"
    aria-hidden="true"
  >
    <div className="size-12 shrink-0 rounded-full bg-gray-100" />
    <div className="flex flex-1 flex-col gap-2">
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-1.5">
          <div className="h-4 w-40 rounded-md bg-gray-100" />
          <div className="h-3 w-56 rounded-md bg-gray-100" />
        </div>
        <div className="h-6 w-14 shrink-0 rounded-full bg-gray-100" />
      </div>
      <div className="h-3 w-full max-w-md rounded-md bg-gray-100" />
      <div className="flex gap-1.5">
        <div className="h-5 w-20 rounded-md bg-gray-100" />
        <div className="h-5 w-24 rounded-md bg-gray-100" />
      </div>
      <div className="mt-1 flex justify-end gap-2">
        <div className="h-10 w-16 rounded-full bg-gray-100" />
        <div className="h-10 w-32 rounded-full bg-gray-100" />
      </div>
    </div>
  </div>
);
